import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  hu: {
    nav: { contact: "Kapcsolat" },
    hero: {
      badge: "360°-os virtuális túrák vállalkozásoknak",
      line1: "Duplázza meg üzlete",
      line2: "forgalmát lenyűgöző",
      line3a: "360°-os",
      line3b: "bemutatókkal",
      sub: "Prémium beltéri videók kereskedőknek, üzleteknek és éttermeknek. Mutassa meg a valóságot, szerezzen több vásárlót.",
      cta: "Ingyenes konzultáció",
      ctaSecondary: "Minta túra indítása",
      stats: [
        { v: "4K HDR", l: "felvételi minőség" },
        { v: "+40%", l: "organikus kattintás" },
        { v: "24 óra", l: "visszajelzési idő" },
      ],
      playerBadge: "360° interaktív nézet",
      dragHint: "Húzza a nézet forgatásához",
      live: "ÉLŐ DEMÓ",
      area: "Kiszállásos szolgáltatás — Balaton régió és országosan",
    },
    marquee: [
      "Éttermek & kávézók",
      "Helyi üzletek & showroomok",
      "Kereskedők & szolgáltatók",
      "Google Maps integráció",
      "+40% organikus kattintás",
      "4K HDR 360° felvétel",
    ],
    benefits: {
      badge: "Kiknek ajánljuk",
      title: "Egy helyszín. Végtelen bejárás.",
      sub: "Három terület, ahol a 360°-os megjelenés az első naptól mérhetően megtérül.",
      cards: [
        {
          title: "Éttermek & Kávézók",
          desc: "Növelje foglalásait: mutassa meg egyedi hangulatát, a meleg világítást és a prémium belső teret még azelőtt, hogy a vendégek belépnének az ajtón.",
        },
        {
          title: "Helyi Üzletek & Showroomok",
          desc: "Építsen digitális bizalmat és növelje az online eltöltött időt. Készlete, butikos hangulata és üzlethangulata a nap 24 órájában bejárható.",
        },
        {
          title: "Kereskedők & Szolgáltatók",
          desc: "Tűnjön ki a helyi Google keresésben és a Térképen: akár 40%-kal magasabb organikus átkattintási arány és erősebb helyi SEO pontszám.",
        },
      ],
    },
    process: {
      badge: "Hogyan működik",
      title: "Három lépés a virtuális jelenléthez",
      steps: [
        {
          num: "01",
          title: "Helyszíni felmérés",
          desc: "Feltérképezzük a legfontosabb vizuális ékeket és az üzlet logisztikáját, hogy minden lényeges részlet a felvételre kerüljön.",
        },
        {
          num: "02",
          title: "360°-os forgatás",
          desc: "Csúcskategóriás professzionális hardverrel rögzítjük a teljes beltéri teret — zavartalanul, akár egyetlen délelőtt alatt.",
        },
        {
          num: "03",
          title: "Integráció",
          desc: "Feltöltjük a kész virtuális túrát a Google Maps és Street View felületekre, és beágyazzuk az Ön weboldalába.",
        },
      ],
    },
    form: {
      badge: "Kapcsolat",
      title: "Kérjen ingyenes konzultációt",
      sub: "Töltse ki az űrlapot — 24 órán belül jelentkezünk a részletekkel.",
      name: "Név",
      business: "Üzlet / cég neve",
      email: "E-mail cím",
      phone: "Telefonszám",
      message: "Üzenet / rövid leírás",
      gdpr: "Hozzájárulok, hogy a Studio vortex 360 az ajánlatkérésem megválaszolása céljából kezelje az általam megadott adatokat. Részletek:",
      gdprLink: "Adatkezelési tájékoztató",
      submit: "Üzenet küldése",
      sending: "Küldés…",
      success: "Köszönjük! Üzenetét megkaptuk, hamarosan jelentkezünk.",
      error: "Hiba történt a küldés során. Kérjük, próbálja újra.",
    },
    reviews: {
      badge: "Google értékelések",
      title: "Ügyfeleink Google értékelései",
      ratingOf: "24 értékelés alapján",
      partner: "Ellenőrzött Google Cégem partner",
      liveBadge: "Élő adatok a Google-tól",
      countLabel: "értékelés",
      items: [
        {
          name: "Kovács Balázs",
          role: "Étterem-tulajdonos, Bistro Lumière",
          text: "A virtuális túra feltöltése óta érezhetően többen térnek be az utcáról, az asztalfoglalásaink pedig 35%-kal nőttek. A vendégek már érkezés előtt kiválasztják, hol szeretnének ülni.",
        },
        {
          name: "Nagy Eszter",
          role: "Üzletvezető, butik bútorbolt",
          text: "A showroomunk végre úgy néz ki online, ahogy a valóságban. Az ügyfelek perceket töltenek a 360°-os bejárással, és célzottan érkeznek — pontosan tudják, mit keresnek.",
        },
        {
          name: "Molnár Péter",
          role: "Helyi kereskedő",
          text: "A Google Térkép profilunk megtekintései megháromszorozódtak a feltöltés után. Profi csapat, gyors munka, mérhető eredmény. Csak ajánlani tudom.",
        },
      ],
    },
    privacy: {
      back: "Vissza a főoldalra",
      title: "Adatkezelési tájékoztató",
      updated: "Utolsó frissítés: 2026. július",
      sections: [
        {
          h: "Az adatkezelő",
          p: "Adatkezelő: Studio vortex 360 (studiovortex360.hu).\nElérhetőség: vortex360studio@gmail.com\nEgyéni vállalkozó, egyéni vállalkozói nyilvántartási szám: 54268041.\nSzékhely: Balatonszemes, Somogy vármegye.\nAdózás: alanyi adómentes (AAM).",
        },
        {
          h: "Milyen adatokat kezelünk?",
          p: "Kizárólag a kapcsolatfelvételi űrlapon önkéntesen megadott adatokat: név, üzlet/cég neve, e-mail cím, telefonszám, valamint az üzenet szabad szöveges tartalma. Más személyes adatot nem gyűjtünk.",
        },
        {
          h: "Az adatkezelés célja és jogalapja",
          p: "Cél: az ajánlatkérés megválaszolása és a kapcsolatfelvétel. Jogalap: az Ön önkéntes hozzájárulása a GDPR 6. cikk (1) bekezdés a) pontja alapján. A hozzájárulást bármikor visszavonhatja az adatkezelő e-mail címén küldött üzenettel.",
        },
        {
          h: "Meddig tároljuk az adatokat?",
          p: "Az adatokat biztonságos adatbázisban tároljuk az érdeklődés lezárásáig, de legfeljebb 12 hónapig, illetve a hozzájárulás visszavonásáig. Törlési kérelmét bármikor elküldheti a vortex360studio@gmail.com címre.",
        },
        {
          h: "Adatfeldolgozók",
          p: "Az űrlap beküldésekor erre a célra szolgáló levélküldő szolgáltatón keresztül e-mail értesítést küldünk az adatkezelő részére. Adatait harmadik félnek marketing célra soha nem adjuk át.",
        },
        {
          h: "Sütik és nyomkövetés",
          p: "Ez a weboldal nem használ nyomkövető vagy marketing sütiket, és nem készít látogatói profilt.",
        },
        {
          h: "Az Ön jogai",
          p: "Kérheti adataihoz való hozzáférést, azok helyesbítését vagy törlését, a kezelés korlátozását, és tiltakozhat az adatkezelés ellen. Panaszával a Nemzeti Adatvédelmi és Információszabadság Hatósághoz fordulhat (NAIH, 1055 Budapest, Falk Miksa utca 9-11., naih.hu).",
        },
        {
          h: "Kapcsolat",
          p: "Adatkezeléssel kapcsolatos kérdésben írjon a vortex360studio@gmail.com címre — 24 órán belül válaszolunk.",
        },
      ],
    },
    terms: {
      back: "Vissza a főoldalra",
      title: "Általános Szerződési Feltételek",
      updated: "Hatályos: 2026. júliustól",
      sections: [
        {
          h: "Általános rendelkezések",
          p: "Szolgáltató: Studio vortex 360 (studiovortex360.hu), elérhetőség: vortex360studio@gmail.com. Egyéni vállalkozó, egyéni vállalkozói nyilvántartási szám: 54268041.\nSzékhely: Balatonszemes, Somogy vármegye.\nAdózás: alanyi adómentes (AAM).\nJelen ÁSZF a Szolgáltató által nyújtott 360°-os virtuális túra- és videokészítési szolgáltatásokra vonatkozik.",
        },
        {
          h: "A szolgáltatások köre",
          p: "A Szolgáltató prémium beltéri 360°-os videókat és virtuális túrákat készít kereskedők, üzletek és éttermek részére, beleértve a helyszíni felmérést, a forgatást, valamint az elkészült anyagok Google Maps / Street View felületekre történő feltöltését és weboldalba ágyazását.",
        },
        {
          h: "Megrendelés és ajánlat",
          p: "A weboldalon található űrlap kitöltése ajánlatkérésnek minősül, szerződést nem hoz létre. A megállapodás a Szolgáltató egyedi, írásbeli ajánlatának a Megrendelő általi elfogadásával jön létre.",
        },
        {
          h: "Árak és fizetés",
          p: "Minden projekt egyedi árazású; az ajánlat tartalmazza a végösszeget és a fizetési ütemezést. A díj számla ellenében, a megállapodás szerinti határidővel fizetendő.",
        },
        {
          h: "Helyszíni felmérés és forgatás",
          p: "A Megrendelő az egyeztetett időpontban biztosítja a helyszínhez való hozzáférést és annak forgatásra alkalmas állapotát. Az időpont módosítása legkésőbb 48 órával a forgatás előtt díjmentes.",
        },
        {
          h: "Teljesítés és átadás",
          p: "A kész virtuális túrát az egyeztetett határidőn belül adjuk át. A Megrendelő egy javítási körrel élhet, amelyet az átadást követő 7 napon belül jelezhet.",
        },
        {
          h: "Szerzői jogok",
          p: "A felvételek felhasználási joga a teljes díj kiegyenlítésével száll át a Megrendelőre. A Szolgáltató a kész munkát referenciaként bemutathatja, kivéve ha a Megrendelő ezt írásban kizárja.",
        },
        {
          h: "Felelősség",
          p: "A Szolgáltató közvetett károkért nem felel. Vis maior (elháríthatatlan külső ok) esetén a határidők arányosan módosulnak, és a felek erről haladéktalanul tájékoztatják egymást.",
        },
        {
          h: "Elállás és panaszkezelés",
          p: "A Megrendelő a forgatás megkezdése előtt díjmentesen elállhat a megrendeléstől. Panaszát a vortex360studio@gmail.com címen jelezheti — 24 órán belül válaszolunk.",
        },
        {
          h: "Záró rendelkezések",
          p: "Jelen ÁSZF-re a magyar jog az irányadó. A Szolgáltató az ÁSZF-t módosíthatja; a módosítás a weboldalon történő közzététellel lép hatályba.",
        },
      ],
    },
    footer: { rights: "Minden jog fenntartva.", tag: "Prémium 360°-os virtuális túrák", privacy: "Adatkezelési tájékoztató", terms: "ÁSZF" },
  },
  en: {
    nav: { contact: "Contact" },
    hero: {
      badge: "360° virtual tours for local businesses",
      line1: "Double Your Foot",
      line2: "Traffic with Immersive",
      line3a: "360°",
      line3b: "Virtual Tours",
      sub: "Premium indoor videos for merchants, shops, and restaurants. Showcase your space, attract more customers.",
      cta: "Free Consultation",
      ctaSecondary: "Play Sample Tour",
      stats: [
        { v: "4K HDR", l: "capture quality" },
        { v: "+40%", l: "organic click-through" },
        { v: "24h", l: "response time" },
      ],
      playerBadge: "360° interactive view",
      dragHint: "Drag to rotate the view",
      live: "LIVE DEMO",
      area: "On-site service — Balaton region & Hungary-wide",
    },
    marquee: [
      "Restaurants & cafes",
      "Local shops & showrooms",
      "Merchants & services",
      "Google Maps integration",
      "+40% organic click-through",
      "4K HDR 360° capture",
    ],
    benefits: {
      badge: "Who it's for",
      title: "One venue. Endless walk-throughs.",
      sub: "Three arenas where a 360° presence pays for itself from day one.",
      cards: [
        {
          title: "Restaurants & Cafes",
          desc: "Boost reservations by showcasing your unique atmosphere, ambient lighting, and premium interior design before guests even arrive.",
        },
        {
          title: "Local Shops & Showrooms",
          desc: "Build digital trust and increase online dwell time. Showcase physical inventory, boutique styling, and retail atmosphere 24/7.",
        },
        {
          title: "Merchants & Services",
          desc: "Stand out in local Google Search and Google Maps results — up to 40% higher organic click-through rates and stronger local SEO scores.",
        },
      ],
    },
    process: {
      badge: "How it works",
      title: "Three steps to a virtual presence",
      steps: [
        {
          num: "01",
          title: "On-site Survey",
          desc: "We map out the key visual highlights and store logistics so every essential detail makes it into the final capture.",
        },
        {
          num: "02",
          title: "360° Shooting",
          desc: "We capture the entire indoor layout with high-end professional hardware — disruption-free, often in a single morning.",
        },
        {
          num: "03",
          title: "Integration",
          desc: "We upload the finished virtual tour to Google Maps and Street View, and embed it seamlessly into your website.",
        },
      ],
    },
    form: {
      badge: "Contact",
      title: "Request a free consultation",
      sub: "Fill in the form — we'll get back to you with the details within 24 hours.",
      name: "Name",
      business: "Business name",
      email: "Email address",
      phone: "Phone number",
      message: "Message / short description",
      gdpr: "I consent to Studio vortex 360 processing the data I provide for the purpose of handling my inquiry. Details:",
      gdprLink: "Privacy Policy",
      submit: "Send message",
      sending: "Sending…",
      success: "Thank you! Your message has been received — we'll be in touch soon.",
      error: "Something went wrong while sending. Please try again.",
    },
    reviews: {
      badge: "Google reviews",
      title: "Our Google Reviews",
      ratingOf: "based on 24 reviews",
      partner: "Verified Google Business Partner",
      liveBadge: "Live data from Google",
      countLabel: "reviews",
      items: [
        {
          name: "Balázs Kovács",
          role: "Restaurant owner, Bistro Lumière",
          text: "Since the virtual tour went live, noticeably more people walk in off the street and our table reservations are up 35%. Guests pick their favourite table before they even arrive.",
        },
        {
          name: "Eszter Nagy",
          role: "Manager, boutique furniture store",
          text: "Our showroom finally looks online the way it does in real life. Customers spend minutes exploring the 360° tour and arrive with intent — they know exactly what they're looking for.",
        },
        {
          name: "Péter Molnár",
          role: "Local merchant",
          text: "Our Google Maps profile views tripled after the upload. Professional team, fast work, measurable results. I can only recommend them.",
        },
      ],
    },
    privacy: {
      back: "Back to home",
      title: "Privacy Policy",
      updated: "Last updated: July 2026",
      sections: [
        {
          h: "Data controller",
          p: "Data controller: Studio vortex 360 (studiovortex360.hu).\nContact: vortex360studio@gmail.com\nSole proprietor, sole trader registration number: 54268041.\nRegistered seat: Balatonszemes, Somogy County, Hungary.\nTaxation: VAT-exempt small taxpayer.",
        },
        {
          h: "What data do we process?",
          p: "Only the data you voluntarily submit via the contact form: name, business name, email address, phone number, and the free-text message. We do not collect any other personal data.",
        },
        {
          h: "Purpose and legal basis",
          p: "Purpose: responding to your inquiry and getting in touch. Legal basis: your voluntary consent under Article 6(1)(a) GDPR. You may withdraw your consent at any time by emailing the controller.",
        },
        {
          h: "How long do we keep your data?",
          p: "Data is stored in a secure database until your inquiry is closed, for a maximum of 12 months, or until you withdraw consent. You may request deletion at any time via vortex360studio@gmail.com.",
        },
        {
          h: "Data processors",
          p: "When the form is submitted, an email notification is sent to the controller through an email delivery provider used solely for this purpose. Your data is never shared with third parties for marketing.",
        },
        {
          h: "Cookies and tracking",
          p: "This website uses no tracking or marketing cookies and does not build visitor profiles.",
        },
        {
          h: "Your rights",
          p: "You may request access to, rectification or erasure of your data, restriction of processing, and you may object to processing. You may lodge a complaint with your local data protection authority (in Hungary: NAIH, 1055 Budapest, Falk Miksa utca 9-11., naih.hu).",
        },
        {
          h: "Contact",
          p: "For any privacy-related question, email vortex360studio@gmail.com — we reply within 24 hours.",
        },
      ],
    },
    terms: {
      back: "Back to home",
      title: "Terms & Conditions",
      updated: "Effective: July 2026",
      sections: [
        {
          h: "General provisions",
          p: "Service provider: Studio vortex 360 (studiovortex360.hu), contact: vortex360studio@gmail.com. Sole proprietor, sole trader registration number: 54268041.\nRegistered seat: Balatonszemes, Somogy County, Hungary.\nTaxation: VAT-exempt small taxpayer.\nThese Terms apply to the 360° virtual tour and video production services provided by the Service Provider.",
        },
        {
          h: "Scope of services",
          p: "The Service Provider produces premium indoor 360° videos and virtual tours for merchants, shops, and restaurants, including on-site surveys, shooting, and uploading the finished material to Google Maps / Street View as well as embedding it into the client's website.",
        },
        {
          h: "Orders and quotes",
          p: "Submitting the form on this website constitutes a request for a quote and does not create a contract. An agreement is formed when the Client accepts the Service Provider's individual written quote.",
        },
        {
          h: "Pricing and payment",
          p: "Every project is priced individually; the quote states the total amount and the payment schedule. Fees are payable by the agreed deadline against an invoice.",
        },
        {
          h: "On-site survey and shooting",
          p: "The Client provides access to the venue at the agreed time and ensures it is in a condition suitable for shooting. Rescheduling is free of charge up to 48 hours before the shoot.",
        },
        {
          h: "Delivery and handover",
          p: "The finished virtual tour is delivered within the agreed deadline. The Client is entitled to one round of revisions, requested within 7 days of delivery.",
        },
        {
          h: "Copyright",
          p: "Usage rights to the footage transfer to the Client upon full payment. The Service Provider may showcase the finished work as a reference unless the Client excludes this in writing.",
        },
        {
          h: "Liability",
          p: "The Service Provider is not liable for indirect damages. In case of force majeure, deadlines are adjusted proportionally and both parties inform each other without delay.",
        },
        {
          h: "Withdrawal and complaints",
          p: "The Client may withdraw from the order free of charge before shooting begins. Complaints can be submitted to vortex360studio@gmail.com — we reply within 24 hours.",
        },
        {
          h: "Final provisions",
          p: "These Terms are governed by Hungarian law. The Service Provider may amend these Terms; amendments take effect upon publication on the website.",
        },
      ],
    },
    footer: { rights: "All rights reserved.", tag: "Premium 360° virtual tours", privacy: "Privacy Policy", terms: "Terms & Conditions" },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("hu");
  const toggle = () => setLang((l) => (l === "hu" ? "en" : "hu"));
  useEffect(() => {
    document.documentElement.lang = lang;
    document.title =
      lang === "hu"
        ? "Studio vortex 360 — 360°-os virtuális túrák"
        : "Studio vortex 360 — 360° Virtual Tours";
  }, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, toggle, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
